import { ActionReturnType, actionCreator, createGuid } from "@itk/typescript-utils";

export enum Action {
  AddAlert = "@@ITK:SRC:COMPONENTS:ITK-TOASTR:ITK-TOASTR-STORE.TS:ACTION:ADDALERT",
  RemoveAlert = "@@ITK:SRC:COMPONENTS:ITK-TOASTR:ITK-TOASTR-STORE.TS:ACTION:REMOVEALERT"
}

export type ItkToastrVariant = "default" | "error" | "success" | "warning" | "info";
export type ItkToastr = {
  id: string;
  message: unknown;
  variant: ItkToastrVariant;
  autoHideDuration: number;
};

type ToastrState = {
  alerts: ItkToastr[];
};

const initialState: ToastrState = {
  alerts: []
};

export const toastActions = {
  addAlert: (message: unknown, variant: ItkToastrVariant, id: string = createGuid(), autoHideDuration = 5000) => actionCreator(Action.AddAlert, { alert: { message, variant, id, autoHideDuration } }),
  removeAlert: (id: string) => actionCreator(Action.RemoveAlert, { id })
};

export const reducer = (state = initialState, action: ActionReturnType<typeof toastActions>): ToastrState => {
  switch (action.type) {
    case Action.AddAlert:
      return { ...state, alerts: [...state.alerts, action.payload.alert] };
    case Action.RemoveAlert:
      return { ...state, alerts: state.alerts.filter(alert => alert.id !== action.payload.id) };
    default:
      return state;
  }
};
